import styled from 'styled-components';

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
